import { render, staticRenderFns } from "./viewAktivenDetailsGeburtstag.vue?vue&type=template&id=1f031145&scoped=true&"
import script from "./viewAktivenDetailsGeburtstag.vue?vue&type=script&lang=js&"
export * from "./viewAktivenDetailsGeburtstag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f031145",
  null
  
)

export default component.exports